import FormProStyle from "../templates/Form.style";
import FormBaseStyle from "../templates/FormBase.style";
var formData = {
  name: 'form',
  data: [{}],
  onlyTemplate: {
    pro: FormProStyle,
    base: FormBaseStyle
  }
};
export default formData;